export class Transaction {
    id: string;
    modified: Date;
    localModified: Date;
    cardHolder: string;
    cardTechnology: number;
    transactionTimestamp: Date;
    localTimestamp: Date;
    lastFour: string;
    transactionAmount: number;
    netAmount: number;
    expirationDate: string;
    transactionStatus: number;
    kioskId: string;
    kioskName: string;
    kioskTimeZone: string;
    kioskTimeAbbreviation: string;
    tenantId: string;
    isProcessed: boolean;
    isResubmitable: boolean;
    isChangeable: boolean;
    isUnprocessed: boolean;
    description: string;
}